import "./../../assets/css/toggle_tabs.css"

const ToggleTab = ({ tab, setTab, items = [] }) => {
  return (
    <div className="toggle-tab-container">
      {items.map((item, index) => {
        const Icon = item.icon;
        const isActive = tab === item.value;

        return (
          <button
            key={index}
            type="button"
            title={item.tooltip || item.label}
            onClick={() => setTab(item.value)}
            disabled={item.disabled || false}
            style={{ cursor: item.cursor || 'pointer' }}
            className={`toggle-tab-button ${isActive ? 'active' : ''}`}
          >
            {Icon && <Icon size={18} />}
            <span className="d-none d-lg-block">{item.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ToggleTab;